import { VStack, Divider, Button } from '@chakra-ui/react'

export const SkipSection = ({ goToNext }: { goToNext: () => void }) => (
  <VStack mt={6}>
    <Divider my={3} maxW={'300px'} />
    <Button onClick={goToNext}>Skip</Button>
  </VStack>
)
